import React from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ModalHeader, ScrollableContent, ModalContainer, ModalContent, ModalRow, ModalRowLabel, ModalRowValue, ModalSection, ModalSectionTitle, } from "../Styles/InputStyles";
import { getModeName } from "../../helpers";
import { Link } from "react-router-dom";
import ModalProfileHeader from "../Common/ModalProfileHeader";
import { capitalizeFirstLetter } from "../../helpers";

const ViewModal = ({ setViewDetail, selectedData }) => {
  const onClose = () => setViewDetail(false);
  const isSettled = selectedData.settleStatus === 3;
  return (
    <Container>
      {/* Header */}
      <ModalHeader>
        <h1 className="text-white text-lg font-medium">View Details</h1>
        <button onClick={onClose}>
          <MdClose color="white" size={24} />
        </button>
      </ModalHeader>

      {/* Top ModalSection */}
      {/* <ProfileSection className="flex justify-between">
        <UserInfo>
          <span className="font-medium mb-0 text-lg">
            {selectedData?.tenantName}
          </span>
          <span className="text-sm text-gray-600">#{selectedData?.roomNum}, {selectedData?.propName}</span>
        </UserInfo>
        <div className="flex flex-col gap-0">
          <span className='text-gray-500 text-sm'>{'Amount Paid'}</span>
          <span className='text-xl font-semibold text-gray-700'>{'₹' + selectedData?.amount}</span>
        </div>
      </ProfileSection> */}
      <ModalProfileHeader
        title="Due Details"
        name={capitalizeFirstLetter(selectedData?.tenantName)}
        subtitle={`#${selectedData?.roomNum} • ${selectedData?.propName}`}
        amountLabel={"Amount Paid"}
        amount={selectedData?.amount}
        image={selectedData?.profilePicture}
        onClose={onClose}
      />

      {/* ModalContent */}
      <ModalContent>
        <ScrollableContent>
          <Wrapper>
            {/* Transaction Details */}
            <BtnWrapper>
              <ModalSectionTitle>Transaction Details</ModalSectionTitle>
            </BtnWrapper>
            <ModalSection>
              <ModalRow>
                <FlexCol>
                  <ModalRowLabel>Amount Paid</ModalRowLabel>
                  <ModalRowValue>{'₹' + selectedData?.amount}</ModalRowValue>
                </FlexCol>
                <FlexCol>
                  <ModalRowLabel>Payment Mode</ModalRowLabel>
                  <ModalRowValue>{getModeName(selectedData?.mode)}</ModalRowValue>
                </FlexCol>
              </ModalRow>

              <ModalRow>
                <FlexCol>
                  <ModalRowLabel>Collection Date</ModalRowLabel>
                  <ModalRowValue>
                    {moment(selectedData?.collectionDate).format(
                      "DD, MMM YYYY, hh:mm A"
                    )}
                  </ModalRowValue>
                </FlexCol>
                <FlexCol>
                  <ModalRowLabel>Due Date</ModalRowLabel>
                  <ModalRowValue>
                    {selectedData?.dueDate ? moment(selectedData?.dueDate).format("DD, MMM YYYY") : '-'}
                  </ModalRowValue>
                </FlexCol>
              </ModalRow>

              <ModalRow>
                <FlexCol>
                  <ModalRowLabel>Recorded By</ModalRowLabel>
                  <ModalRowValue>{selectedData?.recordedBy}</ModalRowValue>
                </FlexCol>
                <FlexCol>
                  <ModalRowLabel>Transaction ID</ModalRowLabel>
                  <ModalRowValue className="break-all whitespace-pre-wrap">{selectedData?.gId}</ModalRowValue>
                </FlexCol>
              </ModalRow>
              {selectedData?.remarks && (
                <ModalRow className="grid-cols-1">
                  <FlexCol>
                    <ModalRowLabel>Remarks</ModalRowLabel>
                    <ModalRowValue>{selectedData?.remarks}</ModalRowValue>
                  </FlexCol>
                </ModalRow>
              )}
            </ModalSection>

            {/* Settlement & Gateway Details */}
            <BtnWrapper>
              <ModalSectionTitle>Settlement Details</ModalSectionTitle>
            </BtnWrapper>
            <ModalSection>
              {isSettled &&
                <>
                  <ModalRow>
                    <FlexCol>
                      <ModalRowLabel>Settled On</ModalRowLabel>
                      <ModalRowValue>{selectedData?.settledOn ? moment(selectedData?.settledOn).format("DD, MMM YYYY, HH:MM") : '-'}</ModalRowValue>
                    </FlexCol>
                    <FlexCol >
                      <ModalRowLabel>UTR</ModalRowLabel>
                      <ModalRowValue>{selectedData?.utrNo || '-'}</ModalRowValue>
                    </FlexCol>
                  </ModalRow>
                </>
              }
              {(isSettled || selectedData?.bankRefNum) &&
                <>
                  <ModalRow>
                    <FlexCol>
                      <ModalRowLabel>Bank Reference</ModalRowLabel>
                      <ModalRowValue>{selectedData?.bankRefNum || '-'}</ModalRowValue>
                    </FlexCol>
                    <FlexCol>
                      <ModalRowLabel>Gateway</ModalRowLabel>
                      <ModalRowValue>{selectedData?.gateway === 1 ? 'PayU' : selectedData?.gateway === 2 ? 'CashFree' : selectedData?.gateway === 3 ? 'Easzebuzz' :
                        '-'}</ModalRowValue>
                    </FlexCol>
                  </ModalRow>
                </>
              }
              <ModalRow>
                <FlexCol>
                  <ModalRowLabel>Account Name</ModalRowLabel>
                  <ModalRowValue>{selectedData?.paymentAccountName || '-'}</ModalRowValue>
                </FlexCol>
                <FlexCol>
                  <ModalRowLabel>Account No</ModalRowLabel>
                  <ModalRowValue>{selectedData?.paymentAccountNo || '-'}</ModalRowValue>
                </FlexCol>
              </ModalRow>
            </ModalSection>


            {/* Documents ModalSection */}
            <BtnWrapper>
              <ModalSectionTitle>Documents</ModalSectionTitle>
            </BtnWrapper>
            <ModalSection>
              {selectedData?.docs && (
                <ModalRow className="grid-cols-1">
                  <FlexCol>
                    <ModalRowLabel>Supporting Document</ModalRowLabel>
                    <ModalRowValue className="text-blue-500 underline">
                      <Link
                        to={selectedData?.docs}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {selectedData?.docs?.split("/").pop()}
                      </Link>
                    </ModalRowValue>
                  </FlexCol>
                </ModalRow>
              )}

              {selectedData?.receipt && (
                <ModalRow className="grid-cols-1">
                  <FlexCol>
                    <ModalRowLabel>Rent Receipt</ModalRowLabel>
                    <ModalRowValue className="text-blue-500 underline">
                      <Link
                        to={selectedData?.receipt}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {selectedData?.receipt?.split("/").pop()}
                      </Link>
                    </ModalRowValue>
                  </FlexCol>
                </ModalRow>
              )}
            </ModalSection>
          </Wrapper>
        </ScrollableContent>
      </ModalContent>
    </Container>
  );
};

export default ViewModal;

// ---------------- Styled Components ----------------
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
